
(function(tabs) {
    

publishingApp.directive('tabs', ['$document', '$window', '$compile', function($document, $window, $compile) {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope, element, attrs) {

            element.bind('click', function (event) {

                var $this = $(event.target.parentElement);
                var $id = $($this.parent().parent().parent());
                var $idUl = $($this.parent().parent());
                if(!$this.hasClass('active')){
                    var attrName = $this.attr('data-name');
                    var elemName = $id.find('#' + attrName);
                    $this.siblings().removeClass('active');
                    $this.addClass('active');
                    $id.find(elemName).siblings().removeClass('active').hide();
                    $id.find(elemName).fadeIn('fast').addClass('active');
                    var num = $this.index();
                    $idUl.find('.v-pane').each(function(index){
                        if(index === num){
                            $(this).siblings().removeClass('active')
                            $(this).siblings().removeClass('is-expanded');
                            $(this).addClass('active')
                            $(this).addClass('is-expanded');
                            $(this).siblings().find('.v-pane-content').removeClass('is-expanded').slideUp();
                            $(this).find('.v-pane-content').addClass('is-expanded').slideDown();
                        }
                    });
                }
            });

            element.bind('click', function (event) {

                var $this = $(event.target).closest('.tab-title');
                var $id = $($this.parent().parent().parent());
                var $idUl = $($this.parent().parent());
                if(!$this.hasClass('active')){
                    var attrName = $this.attr('data-name');
                    var elemName = $id.find('#' + attrName);
                    $this.siblings().removeClass('active');
                    $this.addClass('active');
                    $id.find(elemName).siblings().removeClass('active').hide();
                    $id.find(elemName).fadeIn('fast').addClass('active');
                    var num = $this.index();
                    $idUl.find('.v-pane').each(function(index){
                        if(index === num){
                            $(this).siblings().removeClass('active')
                            $(this).siblings().removeClass('is-expanded');
                            $(this).addClass('active')
                            $(this).addClass('is-expanded');
                            $(this).siblings().find('.v-pane-content').removeClass('is-expanded').slideUp();
                            $(this).find('.v-pane-content').addClass('is-expanded').slideDown();
                        }
                    });
                }
            });



        }
    }
}]);
}('tabs'));

